import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: 'AIzaSyDdmYb_GlfnKL1pjKyLmOs46Y7SorRYuNU',
  authDomain: 'envio-45839.firebaseapp.com',
  projectId: 'envio-45839',
  storageBucket: 'envio-45839.appspot.com',
  messagingSenderId: '960478194919',
  appId: '1:960478194919:web:1e97ef912eb999fe68c642',
  measurementId: 'G-VQXXDDFQM4',
};

const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const messaging = getMessaging(app);

export const fetchToken = (handleToken) => {
  return getToken(messaging, {
    vapidKey:
      'BOGngf7Z5pkgQTV3VcQw3-z5DA9GxgFk0JvpFi-6M0HV4SEmydY2p3eG3mPA8AvjYr9dgTcrDgAm6h8sXQylI1o',
  })
    .then((currentToken) => {
      if (currentToken) {
        handleToken(currentToken);
      } else {
        console.log(
          'No registration token available. Request permission to generate one.'
        );
      }
    })
    .catch((err) => {
      console.log('An error occurred while retrieving token. ', err);
    });
};

export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });

export default app;
